import api from '../../utils/axios';

export const authService = {
  login: async ({ identifier, password, role = 'Agent' }) => {
    const response = await api.post('/auth/login', { identifier, password, role });
    return response.data;
  },

  sendEmailOtp: async ({ email, role = 'Agent' }) => {
    const response = await api.post('/auth/sendOtp', { email, role });
    return response.data;
  },

  sendSmsOtp: async ({ phone_number, role = 'Agent' }) => {
    const response = await api.post('/auth/sendSmsOtp', { phone_number, role });
    return response.data;
  },

  verifyEmailOtp: async ({ email, otp }) => {
    const response = await api.post('/auth/verifyOtp', { email, otp });
    return response.data;
  },

  verifySmsOtp: async ({ phone_number, otp }) => {
    const response = await api.post('/auth/verifySmsOtp', { phone_number, otp });
    return response.data;
  },

  resetPassword: async (payload) => {
    const response = await api.post('/auth/reset-password', payload);
    return response.data;
  },

  sendSignupSmsOtp: async ({ phone_number }) => {
    const response = await api.post('/auth/sendSmsOtpSignup', { phone_number });
    return response.data;
  },

  verifySignupPhoneOtp: async ({ phone_number, otp }) => {
    const response = await api.post('/auth/verifyOtpforPhone', {
      phone_number,
      otp,
      isAgent: true
    });
    return response.data;
  },

  uploadLogo: async (file) => {
    const formDataUpload = new FormData();
    formDataUpload.append('file', file);
    const response = await api.post('/upload/single', formDataUpload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  registerAgent: async (agentData) => {
    const response = await api.post('/agent/register', agentData);
    return response.data;
  }
};

export default authService;
